"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operators = {
    "==": function (l, r) { return l == r; },
    "===": function (l, r) { return l === r; },
    "!=": function (l, r) { return l != r; },
    "!==": function (l, r) { return l !== r; },
    "<": function (l, r) { return l < r; },
    "<=": function (l, r) { return l <= r; },
    ">": function (l, r) { return l > r; },
    ">=": function (l, r) { return l >= r; },
    "&&": function (l, r) { return l && r; },
    "||": function (l, r) { return l || r; }
};
var ifCond = function (v1, operator, v2, options) {
    if (Object.prototype.hasOwnProperty.call(operators, operator))
        return operators[operator](v1, v2) ? options.fn(this) : options.inverse(this);
    return options.inverse(this);
};
exports.default = ifCond;
